import * as React from "react";

import { RequestInitWithRetry } from "@lib/request";
import { UseRequestReturn } from "@lib/useRequest";

import { ClusterContext } from "../../../containers/core/maps/clusterContext";
import { DeviceClusterResponse, DeviceStatsResponse } from "../../../services/core/maps";
import { DevicesCard } from "./devicesCard";
import { ClusterMap } from "./map";

import './clusterMap.css';

export interface ClusterMapContainerProps {
  deviceStatsRequest: UseRequestReturn<DeviceStatsResponse>,
  fetchMapData: (boundingLatLong: string, geotilePrecision: number) => (options: RequestInitWithRetry) => Promise<DeviceClusterResponse>,
  /** false while the containing tab is hidden - see the key on ClusterMap below */
  selected?: boolean
}
export const ClusterMapContainer = (props: ClusterMapContainerProps) => {
  const { state } = React.useContext(ClusterContext);

  return <div className="cluster-map-container">
    {/* key added for re-mount of the leaflet map when the tab goes from being hidden to
        visible - leaflet cannot track container size changes while the map is hidden, so
        resizing the window beforehand otherwise leaves it with stale dimensions and no tiles */}
    <ClusterMap key={`map-${props.selected}`} deviceStatsRequest={props.deviceStatsRequest} fetchMapData={props.fetchMapData} />
    <DevicesCard key={state?.selectedCluster?.join()} />
  </div>;
};
